import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import extraReducers from "../store/extraReducers";

type NotificationsReducerType = {
  orderHistory: boolean;
  advertisementEvents: {
    [key: string]: number;
  };
  orderEvents: {
    [key: string]: number;
  };
};

const initialState = {
  advertisementEvents: {},
  orderEvents: {},
  orderHistory: false,
} as NotificationsReducerType;

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  extraReducers: extraReducers(initialState),
  reducers: {
    setOrderEventTimestamp: (
      state,
      { payload }: PayloadAction<{ orderId: string; timestamp: number }>,
    ) => {
      state.orderEvents[payload.orderId] = payload.timestamp;
    },
    setOrderHistoryBadge: (state, { payload }: PayloadAction<boolean>) => {
      state.orderHistory = payload;
    },
    setAdvertisementEventTimestamp: (
      state,
      { payload }: PayloadAction<{ advertisementId: number; timestamp: number }>,
    ) => {
      state.advertisementEvents[payload.advertisementId] = payload.timestamp;
    },
  },
});

export const { setAdvertisementEventTimestamp, setOrderEventTimestamp, setOrderHistoryBadge } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
